import {useEffect} from 'react';
import {useCountdownContext} from "src/contexts/countdown-context";

const ControllerCountdown = (props) => {
    let {showCountdown, setShowCountdown, tempState, setTempState, ClearStateCountDown} = useCountdownContext();
    let {notification, notifyCaseID,clearNotifyState} = props
    const closeCountdown = async () => {
        if (parseInt(tempState?.caseID) === parseInt(notifyCaseID)) {
            await ClearStateCountDown();
            await clearNotifyState()
        }
    }

    useEffect(() => {
        if (notifyCaseID && notification.dispatch && (notification.dispatch==='a'||notification.dispatch==='r')) {
            closeCountdown();
        }

    }, [notifyCaseID,notification]);
};

export default ControllerCountdown;

